import { useState } from 'react'
import { View } from 'react-native'
import styled, { useTheme } from 'styled-components'
import { Icon } from '../../../../elements/images/Icon'
import { Slider } from '../../../../elements/input/Slider/Slider'
import Button from '../PlayerControls/Button'

const getIconName = (volume, muted) => {
  if (muted) return 'volume-off'
  if (volume === 0) return 'volume-muted'
  if (volume > 0 && volume < 0.6) return 'volume-down'
  if (volume > 0.5) return 'volume-up'
}

const ControlsContainer = styled(View)`
  position: absolute;
  top: ${(props) => -props.offset}px;
  left: 15px;
  width: 50px;
`

const SliderModal = styled(View)`
  align-items: center;
  height: ${(props) => props.height}px;
  background: ${(props) => props.theme.colors.background};
  padding: ${(props) => `${props.theme.spacing.md}px ${props.theme.spacing.sm * 1.5}px`};
`

export const VolumeControls = ({ muted, toggleMute, volume, onChange, iconSize }) => {
  const theme = useTheme()
  const sliderHeight = 100 + theme.spacing.md * 2
  const [sliderShown, setShown] = useState(false)
  return (
    <View onMouseEnter={() => setShown(true)} onMouseLeave={() => setShown(false)}>
      <ControlsContainer isShown={sliderShown} offset={sliderHeight}>
        {sliderShown && (
          <View>
            <SliderModal height={sliderHeight}>
              <Slider
                vertical
                step={0.01}
                value={muted ? 0 : volume}
                maximumValue={1}
                onValueChange={onChange}
                minimumTrackTintColor={theme.colors.primary}
                maximumTrackTintColor={theme.colors.grayDark}
                handleStyle={{
                  borderColor: theme.colors.grayLighter,
                  backgroundColor: theme.colors.grayLighter,
                  borderRadius: 0,
                  height: 8,
                }}
              />
            </SliderModal>
          </View>
        )}
      </ControlsContainer>

      <Button onPress={toggleMute}>
        <Icon name={getIconName(volume, muted)} size={iconSize} />
      </Button>
    </View>
  )
}
